import { useQuery } from '@tanstack/react-query';

import { PublicHolidayListResource } from '@/types/resources';
import { api } from '@/utils/api';

const usePublicHolidayListsOptions = () => {
  return useQuery(
    ['public-holiday-lists'],
    () =>
      api.get<never, PublicHolidayListResource[]>(
        '/v1/payments/freelancers/holidays/public-holiday-lists',
      ),
    {
      select: (data) => [
        { value: null, label: 'None' },
        ...data.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      ],
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true,
    },
  );
};

export default usePublicHolidayListsOptions;
